import React, { useState, useEffect, useMemo, useRef } from 'react';
import ErrorMessages from '../../../components/ErrorMessages.js/index.js';
import Input from '../../../components/Input/index.js';
import Textarea from '../../../components/Textarea/index.js';
import InputFile from '../../../components/InputFile/index.js';
import Button from '../../../components/Button/index.js';
import ItemImage from '../../../components/ItemImage/index.js';
import Checkbox from '../../../components/Checkbox/index.js';
import Select from '../../../components/Select/index.js';
import DatePicker from '../../../components/DatePicker';
import useModal from '../../../customHooks/useModal.js';
import requsetErrorMessage from '../../../helpers/requsetErrorMessage.js';
import { useForm } from 'react-hook-form';
import translations from '../../../translations/de.js';

import API from '../../../api/notificationsPush.js';

import './FieldsStyle.scss';

import {
    RecipientTypesEnum,
    getRecipientByValue,
} from '../../../constants/notificationRecipients.js';
import { NotificationGroupsEnum } from '../../../constants/notificationGroupsEnum.js';
import { NotificationTypesEnum } from '../../../constants/notificationTypeEnum.js';
import { NotificationCampaignsEnum } from '../../../constants/notificationCampaignsEnum.js';
import { NotificationScreensOptions } from '../../../constants/notificationScreensOptions.js';
import Loader from '../../../components/Loader/index.js';
import { ISOStoStingTimeOnly } from '../../../helpers/dateToISOStringInObj.js';
import NotificationCampaignPreview from './../../../components/NotificationCampaignPreview/NotificationCampaignPreview';

const BirthdayType = ({ isEditable, closeEditable }) => {
    const [campaignData, setCampaignData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageLoader, setPageLoader] = useState(false);
    const [disabled, setDisabled] = useState(!isEditable);

    const previewRef = useRef(null);
    const [preview, showPreview] = useModal(false, previewRef);

    const [resetImageUrl, setResetImageUrl] = useState(null);

    const [showExternalLink, setShowExternalLink] = useState(false);

    const formFields = useMemo(
        () => ({
            text: campaignData?.templates[0]?.text,
            image: campaignData?.templates[0]?.image,
            title: campaignData?.templates[0]?.title,
            delivery_time: ISOStoStingTimeOnly(campaignData?.delivery_time),
            start_date: campaignData?.start_date,
            paused: campaignData?.paused,
            credits: campaignData?.credits,
            internal_navigation: campaignData?.data?.internal_navigation,
            external_navigation: campaignData?.data?.external_navigation,
        }),
        [campaignData],
    );

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        reset,
        control,
        getValues,
    } = useForm({
        defaultValues: formFields,
    });

    const handleClose = () => {
        reset(formFields);
        setResetImageUrl(null);
        closeEditable();
    };

    const submitHandler = (data) => {
        setLoading(true);
        setError(null);

        data.group = NotificationGroupsEnum.WITH_BIRTHDAY;
        data.notification_type = NotificationTypesEnum.CAMPAIGN_BIRTHDAY;
        data.campaign_type = NotificationCampaignsEnum.BIRTHDAY;

        const {
            text,
            title,
            image,
            internal_navigation,
            start_date,
            delivery_time,
            external_navigation,
            ...rest
        } = data;

        const notifData = {
            ...rest,
            start_date: start_date ? new Date(start_date).toISOString() : start_date,
            delivery_time: delivery_time ? new Date(delivery_time).toISOString() : delivery_time,
            templates: [{ title: title, text: text, image: image }],
            data: {
                ...(showExternalLink
                    ? { external_navigation }
                    : { internal_navigation: internal_navigation }),
            },
        };

        try {
            API.editNotification({ items: [notifData] });
            closeEditable();
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setDisabled(!isEditable);
    }, [isEditable]);

    useEffect(() => {
        const getBdayCampaign = async () => {
            try {
                setPageLoader(true);
                const res = await API.getCampaign({
                    params: { campaign_type: NotificationCampaignsEnum.BIRTHDAY },
                });
                setCampaignData(res.data.items[0]);
            } catch (e) {
                console.error(e);
            } finally {
                setPageLoader(false);
            }
        };
        getBdayCampaign();
    }, []);

   useEffect(() => {
       if (campaignData) {
           setTimeout(() => {
               reset(formFields);
           }, 0);
           setResetImageUrl({ image: campaignData.templates[0].image });
       }
   }, [campaignData, formFields, reset]);

    useEffect(() => {
        if (resetImageUrl) {
            reset({ ...watch(), ...resetImageUrl });
        }
    }, [resetImageUrl, reset, watch]);
    
    return (
        <div className="New-Notification">
            {!disabled && (
                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        gap: '10px',
                        justifyContent: 'flex-end',
                    }}
                >
                    <Button label={translations.cancel} type="button" onClick={handleClose} />
                    <Button
                        loading={loading}
                        label={translations.save}
                        type="submit"
                        onClick={handleSubmit(submitHandler)}
                    />
                </div>
            )}
            {!pageLoader ? (
                <div>
                    <div className="preview-wrapper">
                        <div className="sendTo">
                            <span>
                                {translations.send_to}:{` `}
                                {getRecipientByValue(RecipientTypesEnum.WITH_BIRTHDAY)?.label}
                            </span>
                        </div>
                        <div>
                            <Button
                                theme="gray"
                                label={translations.preview}
                                loading={loading}
                                onClick={() => showPreview(true)}
                            />
                        </div>
                    </div>

                    <form onSubmit={handleSubmit(submitHandler)}>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <Input
                                placeholder={translations.title}
                                label={translations.title}
                                name="title"
                                {...register('title', {
                                    required: true,
                                })}
                                disabled={disabled}
                                error={errors.title}
                            />
                            <Textarea
                                placeholder={translations.message}
                                label={translations.text}
                                name="text"
                                {...register('text', {
                                    required: true,
                                })}
                                disabled={disabled}
                                error={errors.text}
                            />
                        </div>
                        <InputFile
                            label={translations.image}
                            name="image"
                            {...register('image', {
                                required: false,
                            })}
                            disabled={disabled}
                            error={errors.image}
                            pathToCloudFolder="uploads/notifications"
                            resetValue={(val) => setResetImageUrl({ image: val })}
                        />
                        <ItemImage imgSrc={resetImageUrl?.image ?? campaignData?.image} />
                        <div
                            style={{
                                display: 'flex',
                                gap: '30px',
                                width: '820px',
                                alignItems: 'center',
                            }}
                        >
                            <div className="timepicker">
                                <DatePicker
                                    label={translations.delivery_time}
                                    selectText="Pick Time"
                                    name="delivery_time"
                                    timeOnly={true}
                                    required={true}
                                    control={control}
                                    disabled={disabled}
                                    error={errors.delivery_time}
                                />
                            </div>
                            <div className="datepicker">
                                <DatePicker
                                    label={translations.starting_date}
                                    name="start_date"
                                    withTime={true}
                                    control={control}
                                    selectText="Select a date..."
                                    disabled={disabled}
                                    error={errors.start_date}
                                />
                            </div>

                            <div>
                                <Checkbox
                                    text={translations.paused}
                                    name={'paused'}
                                    {...register('paused', { required: false })}
                                    disabled={disabled}
                                    error={errors.paused}
                                />
                            </div>
                        </div>
                        <div className="timepicker">
                            <Input
                                label={translations.credits}
                                name="credits"
                                defaultValue={'0'}
                                placeholder="0"
                                type="number"
                                {...register('credits', {
                                    required: true,
                                    valueAsNumber: true,
                                })}
                                disabled={disabled}
                                error={errors.credits}
                            />
                        </div>
                        <div className="externalLinkWrapper">
                            <div className="checkbox">
                                <Checkbox
                                    name="external_link"
                                    text="External Link"
                                    defaultValue="false"
                                    outerStyle={{ alignSelf: 'center' }}
                                    onChange={() => setShowExternalLink((prev) => !prev)}
                                    disabled={disabled}
                                />
                            </div>
                            {showExternalLink ? (
                                <Input
                                    label={translations.external_link}
                                    name="external_navigation"
                                    placeholder="Type here..."
                                    type="text"
                                    {...register('external_navigation', {
                                        required: false,
                                        validate: {
                                            checkUrl: (value) => {
                                                if (!value) {
                                                    return true;
                                                }
                                                try {
                                                    new URL(value);
                                                    return true;
                                                } catch (error) {
                                                    return 'Invalid URL';
                                                }
                                            },
                                        },
                                    })}
                                    style={{ flex: '1' }}
                                    disabled={disabled}
                                    error={errors.external_navigation}
                                />
                            ) : (
                                <div className="screen-picker">
                                    <Select
                                        label="Screen"
                                        name="internal_navigation"
                                        control={control}
                                        placeholder="Select Screen"
                                        options={NotificationScreensOptions.map((screen) => ({
                                            value: screen.value,
                                            label: screen.label,
                                        }))}
                                        disabled={disabled}
                                    />
                                </div>
                            )}
                        </div>
                    </form>
                    <ErrorMessages
                        messages={requsetErrorMessage(
                            error && error.message ? error.message : error,
                        )}
                    />
                </div>
            ) : (
                <div className="Page-Loader">
                    <Loader theme="dark" size="big" />{' '}
                </div>
            )}
            {preview && campaignData && (
                <NotificationCampaignPreview
                    data={
                        disabled
                            ? campaignData
                            : {
                                  ...getValues(),
                                  notification_type: NotificationTypesEnum.BIRTHDAY,
                                  campaign_type: NotificationCampaignsEnum.BIRTHDAY,
                              }
                    }
                    onClose={() => showPreview(false)}
                />
            )}
        </div>
    );
};

export default BirthdayType;
